import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TextRowWithReader = ({ leftText, rightText, className = '' }) => {
    return (_jsxs("div", { className: `flex flex-row w-full flex-nowrap justify-between ${className}`, "aria-label": `${leftText} ${rightText}`, children: [_jsx("span", { children: leftText }), _jsx("div", { className: "leader" }), _jsx("span", { children: rightText })] }));
};
export default TextRowWithReader;
